export default {
  home: {
    banner: {
      "title-first": "客户的成功",
      "title-second": "就是 Authing 的成功",
      subtitle: "Authing 已帮助 30000+ 家企业和开发者构建标准化的用户身份体系",
      "data-label-count": "客户数量",
      "data-label-industry": "涉及行业",
      "data-label-time": "服务时间",
    },
    example: {
      "heigh-educate": {
        title: "高等教育出版社 - 传统企业的转型之路",
        subtitle:
          "高等教育出版社是中国教育出版传媒集团有限公司的成员单位，是以出版高等教育、职业教育、成人及社会教育等教育类、专业类、科技类出版物为主的综合性大型出版社，本门户网站提供企业资讯、出版图书、数字化产品及课程、教学资源信息。",
        label1: "教育",
        label2: "B2C",
      },
    },
    cardList: {
      title: "了解我们的客户故事",
      item1: {
        title: "高教社",
        text:
          "Authing 帮助高等教育出版社打造智慧身份平台，为用户带来便捷、舒适、适合的登录体验。",
      },
      item2: {
        title: "元气森林",
        text:
          "Authing 通过实现基于飞书组织架构下的不同权限不同访问级别，节省元气森林 80% 的运维工作量。",
      },
      item3: {
        title: "中国石油",
        text: "Authing 提供全套的 C# SDK，满足中国石油快速接入其研发系统。",
      },
      item4: {
        title: "东南大学",
        text:
          "Authing 使用跨平台的 SDK，用五行代码帮助东南大学实现跨平台的用户系统（包含小程序）。",
      },
      item5: {
        title: "大众汽车",
        text:
          "Authing 联邦认证通过标准协议帮助大众汽车建立起上下游合作伙伴各应用提供商之间的信任。",
      },
      item6: {
        title: "宾利汽车",
        text:
          "Authing 帮助宾利汽车轻松处理用户登录的任何数据，间接很大程度提高了研发工作效率。",
      },
      item7: {
        title: "日本丰田",
        text:
          "Authing 帮助丰田快速集成他们的新老应用，大大减缩减了新应用的研发周期和上市时间。",
      },
      item8: {
        title: "JCDcaux",
        text:
          "Authing 为德高集团搭建了统一认证中心，帮助德高集团完成了身份管理和设备管理服务。",
      },
      item9: {
        title: "BOSCH",
        text:
          "Authing 用可伸缩性、高扩展的 SaaS  平台部署模式，大大缩短了博世集团的研发周期。",
      },
      item10: {
        title: "PingCAP",
        text:
          "Authing 对员工入离职管理和信息同步的产品能力，帮助 PingCAP 大大降低了运维时间和成本。",
      },
      item11: {
        title: "四川大学华西医院",
        text:
          "Authing 为四川大学华西医院构建了身份供应体系，减少因人员身份管理不规范带来的信息安全风险。",
      },
      item12: {
        title: "Bentley",
        text:
          "Authing 为奔特利（Bentley）保障了其内部开发者和外部用户登录和身份验证时的安全性。",
      },
      item13: {
        title: "Nreal",
        text:
          "Authing 提供 1000+ API 和多语言的 SDK，为 Nreal 快速实现三端的身份统一，及安全合规的登录认证功能。",
      },
      item14: {
        title: "仙工智能",
        text:
          "Authing 为仙工智能实现了对内的员工身份管理和对外的客户身份管理，大大节省了开发的时间精力。",
      },
      item15: {
        title: "Alpha Cen",
        text:
          "Authing 提供各类工程软件及平台的接口，帮助 Alpha Cen 用很少的精力，搭建起完整的身份认证管理平台。",
      },
      item16: {
        title: "CSDN",
        text:
          "Authing 提供 32 种国内外社会化登录能力，以及 1000+ API/SDK，帮助 CSDN 缩短一个月的研发周期。",
      },
      item17: {
        title: "裕信银行",
        text:
          "Authing 具备多元的多因素认证方式和自适应的安全策略，能帮助企业实现更安全的登录认证和身份管理。",
      },
    },
  },
  "heigh-educate": {
    banner: {
      title: "高等教育出版社",
      subtitle:
        "Authing 帮助高等教育出版社打造智慧身份平台，为用户带来最便捷、最舒适、最适合的登录体验。",
      brandDescript: `“对比过众多厂商后更能感受到 Authing 的优势，这是一款经过思考做出来的产品。”`,
    },
    intro: {
      title: "客户介绍",
      imgUrl: "//files.authing.co/authing-website/customer-intro-hep-zn.png",
      descript1:
        "高等教育出版社（以下简称高教社）成立于 1954 年 5 月，是新中国最早设立的专业教育出版机构之一。高教社现有在职员工 1700 余人，年出书万余种，发行近 1.3 亿册。出版社规模、员工数量居国内出版社前列。",
      descript2:
        " 在教育部的领导下，高教社承担了全国高校思想政治工作网、中国大学生在线两个网站的建设和运营工作，目前思政网已覆盖各省级党委教育工作部门、75 所教育部直属高校和其他部委高校、2500 所地方高校。中国大学生在线网站会员总数已达到 1120 万人，再创历史新高。",
      descript3:
        "高教社与包括众多知名出版商在内的全球 200 多家机构开展广泛的合作，24 个语种版本的国际型产品在世界 60 多个国家发行，版权输出数量在全国单体出版社中连年名列前茅。连续多次被评为国家文化出口重点企业。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description: "高教社的 3500 万用户分布在几十个软件平台，IT 管理复杂。",
      },
      item2: {
        title: "问题二",
        description:
          "高教社需要出色的用户登录体验，提高与国内教育市场、国际出版商的合作。",
      },
      item3: {
        title: "问题三",
        description: "承担思政网的建设工作，意味着防欺诈、安全保障格外重要。",
      },
      item4: {
        title: "问题四",
        description:
          "运营思政网、大学生在线网等多个网站，高教社对跨品牌单一登录的需求强烈。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "舒适的用户体验",
        subtitle:
          "在与高教社的合作中，Authing 团队提供全程一对一的咨询与技术服务，加速网站上线，并用 Authing SDK 诸如 Java、Delphi 支持客户成功。",
      },
      item2: {
        title: "保障企业身份信息安全",
        subtitle:
          "通过提供多因素认证、登录环境监测等安全技术，Authing 为高教社打造了专业的安全防护。",
      },
      item3: {
        title: "完善的身份服务",
        subtitle:
          "凭借 Authing 完善的身份认证和访问管理服务，两位工程师用了一个下午就完成了部署测试，轻松集成了高教社的千万用户。实现了在一处、用一个账号跨品牌登录的体验。",
      },
      item4: {
        title: "提高系统的可扩展性",
        subtitle:
          "Authing 平台弹性灵活，文档、软件包丰富，在高教社的迅速发展中，为其提供了拓展、集成能力，减少日常的维护工作，降低未来的开发成本，打造高效愉悦的开发方式，让 IT 管理化繁为简，加速业务成长。",
      },
    },
  },
  cnpn: {
    banner: {
      title: "中国石油",
      subtitle:
        "Authing 提供完善的单点登录平台，帮助中国石油快速实现高效用户管理。",
    },
    intro: {
      title: "客户介绍",
      imgUrl: "//files.authing.co/authing-website/customer-intro-cnpn-zn.png",
      descript1:
        "中国石油天然气集团有限公司是国有重要骨干企业和中国主要的油气生产商和供应商之一，是集油气勘探开发、炼油化工、销售贸易、管道储运、工程技术、工程建设、装备制造、金融服务于一体的综合性国际能源公司，在国内油气勘探开发中居主导地位，在全球 35 个国家和地区开展油气业务。",
      descript2:
        "2020 年，公司在世界 50 家大石油公司综合排名中位居第三，在《财富》杂志全球 500 家大公司排名中位居第四。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "中国石油旗下某研究所总计千余人，使用的软件服务总计 10 余个，IT 管理复杂。",
      },
      item2: {
        title: "问题二",
        description:
          "公司希望其成员使用该公司账号即可登录所有软件，然而现有业务系统老旧，安全、认证创新困难。",
      },
      item3: {
        title: "问题三",
        description:
          "核心功能研发本身已耗时许久，然而用户验证功能却一直未处理完善，公司希望加速研发周期。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "舒适的用户体验",
        subtitle:
          "Authing 提供了完善的单点登录平台，为旗下 Web 和 App 均快速实现了用户验证和访问管理功能。",
      },
      item2: {
        title: "保障企业身份信息安全",
        subtitle: "Authing 提供全套的 C# SDK，满足中国石油快速接入其研发系统。",
      },
      item3: {
        title: "完善的身份服务",
        subtitle:
          "在中国石油重点关注的移动端单点登录上，Authing 具备「自动检测同一设备上关联应用的登录状态」、「唤起关联 App 以交换用户信息」，方便中国石油依据场景做出选择。",
      },
    },
  },
  dongnan: {
    banner: {
      title: "东南大学",
      subtitle: "五行代码帮助东南大学实现跨平台用户系统的单点登录。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-dongnan-zn.png",
      descript1:
        "东南大学坐落于六朝古都南京，是享誉海内外的著名高等学府。学校是国家教育部直属并与江苏省共建的全国重点大学，是国家「985 工程」和「211 工程」重点建设大学之一。",
      descript2:
        "东南大学现有 33 个院系、77 个本科专业，有 33 个博士学位一级学科授权点，49 个硕士学位一级学科授权点。有全日制在校生 30664 人，其中本科生 16128 人、研究生 14536 人；在校留学生 1989 人，其中学历留学生 1547 人。学校建有四牌楼、九龙湖、丁家桥等校区，占地面积 5888 亩，其中九龙湖校区 3752.35 亩，总建筑面积约 78.97 万平方米。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title:
          "东南大学在开发 BIM 系统时遇到单点登录问题，需要联合自研系统（BIM 系统）和三方系统（Odoo、Strapi、C9.io）做统一认证和授权，而 BIM 系统本身的研发极其复杂，若同时进行单点登录的研发将拖慢项目上线速度，最终影响工地工作人员使用。并且，该 BIM 系统除了 Web 端外，还存在小程序端，多端跨平台的用户系统研发又会引入其他复杂性问题。另外由于 BIM 组织机构复杂，需要细粒度的权限分级，研发基于角色的授权模型又将拖慢系统上线速度。",
        description: "",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 重视教育市场，为东南大学提供全程一对一的咨询与技术服务，加速其系统上线，支持业务成功。",
      },
      item2: {
        title: "",
        subtitle:
          "Authing 使用基于 OAuth 2.0 的单点登录方案，连接 BIM 系统和 Odoo、Strapi 和 C9.io；使用基于 RBAC 的授权方案，统一对组织机构和工作人员进行授权分级；使用跨平台的 SDK（Java、Delphi、C#、Node 等），用五行代码实现跨平台的用户系统（包含小程序）。",
      },
    },
  },
  "xian-gong": {
    banner: {
      title: "仙工智能",
      subtitle:
        "我们高度重视供应商应用的灵活性与可靠性，Authing 的「嵌入、集成、连接」理念与我们的需求不谋而合。合作后，我们快速地通过 Authing 完成了对内的员工身份管理和对外的客户身份管理，大大节省了我们的时间精力。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-xiangong-zn.png",
      descript1:
        "上海仙工智能科技有限公司（简称 SEER）是一家专注于智能生产和智慧物流的高新技术企业，业务涵盖了通用 AMR 控制器、企业数字化中台、基于视觉系统的车厂协同方案以及自动叉车在内的各类 AMR，为各行业的客户提供一站式全感知物流解决方案，以标准产品支撑非标应用，致力于推动工业的信息化、数字化、智能化转型升级。",
      descript2:
        "从发现需求到解决需求，从解决需求到创造需求，SEER 坚持在客户需求与自身的多层次需求中寻找突破，聚焦工业智能化，进行开放式创新，为合作伙伴创造价值。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "企业内部应用系统分散，数据相互隔离，需在多处进行操作，难以统一管理，存在数据孤岛效应。",
      },
      item2: {
        title: "问题二",
        description:
          "随着业务推进和员工数量激增，业务场景和组织架构逐渐复杂，内部员工的权限管理和分配成为了难题。",
      },
      item3: {
        title: "问题三",
        description:
          "企业内部系统间，没有统一的身份认证授权流程。导致用户使用应用系统时需重复认证，影响生产效率。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "以 Authing 身份云作为统一身份管理平台，能帮助企业打通应用间的身份体系，统一员工的访问入口，在一处操作，即可同步数据至所有下游应用。",
      },
      item2: {
        title: "",
        subtitle:
          "Authing 基于 RBAC/ABAC 权限模型，能帮助企业实现灵活且细粒度的权限管理；并提供动态的安全策略和大量 API，方便开发者构建符合业务需求的权限管理系统。",
      },
      item3: {
        title: "",
        subtitle:
          "Authing 支持多种标准的认证授权协议：OIDC、OAuth2、SAML、CAS 等，能帮助企业快速实现统一的认证授权流程，提高生产效率。",
      },
    },
  },
  deephow: {
    banner: {
      title: "Deephow",
      addtionTitle: "（深昊科技）",
      subtitle: `Authing 为 Deephow（深昊科技）提供自定义程度高的社会化登录，为其用户带来最便捷的第三方登录体验。`,
      brandDescript: ``,
    },
    intro: {
      title: "客户介绍",
      imgUrl: "//files.authing.co/authing-website/customer-intro-deephow.png",
      descript1:
        "Deephow（深昊科技）开发了一个由 AI 驱动的学习平台，致力于为制造业、服务业等提供 AI 教学培训和智能视频培训服务，让用户在产品安装使用时能更省时省事。",
      descript2:
        "Deephow 的这一解决方案能帮助企业客户减少前期产品投入使用时的教育培训成本，这比传统的线下培训形式投入的资源要节省10倍，从而广受客户欢迎。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title:
          "Deephow（深昊科技）需要寻求一家提供简单易用的社会化登录平台，简化其用户在第三方平台诸如微信、win form 等的登录体验，同时为其用户在第三方平台创建账号提供一种更加简单便捷的方式。",
        description: "",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "在与 Deephow（深昊科技）的合作中，Authing 团队提供全程一对一的咨询与技术服务，支持客户成功。",
      },
      item2: {
        title: "",
        subtitle:
          "通过使用 C# SDK 的接入方式，Authing 为 Deephow（深昊科技）提供可自定义程度高的社会化登录，为其用户带来更加便捷的第三方账号创建&登录体验。",
      },
    },
  },
  theragun: {
    banner: {
      title: "THERAGUN",
      addtionTitle: "（赛锐康）",
      subtitle:
        "Authing 帮助 THERAGUN 打造易用性高的统一身份认证平台，完美实现应用无缝对接，提升用户体验。",
      brandDescript: ``,
    },
    intro: {
      title: "客户介绍",
      imgUrl: "//files.authing.co/authing-website/customer-intro-theragun.png",
      descript1:
        "THERAGUN 是美国最大的筋膜枪品牌，成立于 2008 年。其产品采用独创的冲击式疗法深层按摩肌肉，可以起到缓解肌肉紧张、加速恢复、提高身体机能的作用，同时还为用户提供舒缓肌肉、缓解疼痛用的外敷产品。",
      descript2:
        "全球有 250 多支专业运动队（NFL、NBA、NHL、MLB、MLS、NASCAR）信赖 THERAGUN ，全球 50 余个国家/地区的教练、理疗师、脊医和普通大众亦在使用。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title:
          "THERAGUN 已经在他们的电子商务网站上使用了 Shopify 的认证，但 Shopify 在身份认证解决方案上专业度不够。考虑到产品的易用性，THERAGUN 决定采用更专业的登录解决方案，来解决现有应用系统复杂的登录模式，实现统一身份认证。",
        description: "",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 为 THERAGUN 提供了新的统一认证系统，并在短短 7 周的时间内完成他们所有客户的迁移，缓解了大量客户登录和认证带来的压力。",
      },
      item2: {
        title: "",
        subtitle:
          "凭借 Authing 完善的身份认证和访问管理服务，共计为 THERAGUN 节省了约 60 万美元的技术人力成本，并省去了接近 50 %的开发工时。",
      },
    },
  },
  bentley: {
    banner: {
      title: "Bentley",
      addtionTitle: "（奔特利）",
      subtitle:
        "Authing 为奔特利（Bentley）内部开发者和外部用户均提供的无缝、便捷而又安全的认证体验，保障其登录和身份验证时的安全性。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-intro-bentley-zn.png",
      descript1:
        "Bentley（奔特利）工程软件有限公司成立于 1984 年，员工 4000 多人，在全球 172 个国家设有分支机构，年收入超过 8 亿美元，被评为全球第二大地理信息软件解决方案提供商。",
      descript2:
        "Bentley（奔特利）通过为企业和专业人员提供基于设计、建造和运营公路、桥梁、轨道交通、给排水、公共工程和公用事业、园区以及工业设施的解决方案。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "作为一家全球性的企业，Bentley（奔特利）已经在全球范围内已经完成了身份体系的搭建，但现阶段使用的身份管理产品无法满足奔特利（Bentley）中国团队业务的快速发展的需求，中国团队希望寻求一家国内的优秀身份认证提供商，来快速完成现有应用系统与身份的集成。",
      },
      item2: {
        title: "问题二",
        description:
          "单一的认证访问方式，业务安全无法保障。现在 Bentley（奔特利）中国的业务采用用户名+密码的单一认证方式，安全性得不到保证，部分系统密码设置也不符合密码的要求，存在安全隐患。",
      },
      item3: {
        title: "问题三",
        description:
          "缺乏清晰实时操作和安全访问审计，无法满足企业安全合规上的需求。随着业务的快速发展，针对用户访问、权限使用和数据管理，缺乏实时有效的事前预警、事中审计和事后追溯的路径。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "舒适的用户体验",
        subtitle:
          "Authing 提供了完善的单点登录平台，为旗下 Web 和员工系统均快速实现了高效的认证和访问管理功能。",
      },
      item2: {
        title: "保障企业身份信息安全",
        subtitle:
          "Authing 提供了多种认证方式供 Bentley（奔特利）选择：组合、密码策略、登录频繁检测、自定义认证流程等，并且都可以通过管理控制台轻松配置完成。",
      },
      item3: {
        title: "完善的身份服务",
        subtitle:
          "Authing 基于用户行为审计、管理员审计和应用访问情况为 Bentley（奔特利）实现了可视化安全审计的策略，支持不同人员（组）设定不同的密码策略。多因素认证让用户访问无缝、敏捷和安全。",
      },
    },
  },
  futu: {
    banner: {
      title: "富途牛牛",
      addtionTitle: "",
      subtitle:
        "富途牛牛通过 Authing 实现企业微信安全登录和扫码认证，保障企业信息安全。",
    },
    intro: {
      title: "客户介绍",
      imgUrl: "//files.authing.co/authing-website/customer-intro-futu-zn.png",
      descript1:
        "深圳市富途网络科技有限公司成立于 2007 年，是腾讯战略投资，纳斯达克上市公司富途控股（NASDAQ: FUTU）旗下子公司，主要从事互联网科技类产品的研发，提供面向个人投资者的市场数据、资讯、社交等服务。",
      descript2:
        "旗下富途证券等美港股券商提供面向个人投资者的美股、港股、A 股通的股票交易和清算、融资融券、财富管理等服务，并以用户为中心构建完善的金融科技生态系统，连接用户、投资者、企业、证券分析师、媒体和意见领袖。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "",
        description:
          "富途公司在内部同时使用腾讯企业微信和腾讯会议进行日常经营管理，希望实现通过企业微信直接登录到腾讯会议。但如果通过企业微信自有应用直接认证的方式，会将组织机构、邮箱、手机号等私密信息直接暴露出来，造成企业安全风险。此外，需要保证企业微信的密钥信息安全可控，不可以存放在公网或第三方环境。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "员工通过 Authing 中的企业微信登录腾讯会议并按企业微信中设定的不同组织架构和权限进入会议。",
      },
      item2: {
        title: "保障企业身份信息安全",
        subtitle:
          "通过 Authing 的 IDaaS 产品中「企业微信（第三方应用）扫码登录」功能进行桥接，使用 OpenID Connection 协议实现企业微信扫码认证。",
      },
    },
  },
  jcdecaux: {
    banner: {
      title: "JCDecaux",
      addtionTitle: "（德高集团）",
      subtitle:
        "Authing 为德高集团搭建了统一认证中心，提供的身份供应功能，帮助德高集团完成了身份管理和设备管理服务，形成完整统一且权威的身份数据源，提高广告投放效率 75%。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-jcdcaux-zn.png",
      descript1:
        "德高集团 (JCDecaux Group) 创立于 1964 年，是全球排名第一的国际性户外媒体公司，并在巴黎 Euronext 上市。业务遍布全球 50 多个国家的 3,688 个城市，2005 年 ，德高进入中国市场，业务遍及 12 个城市（含香港澳门），163,355 广告位，21% 城镇人口覆盖，每日触达受众 1.7 亿人次。在中国有 1300 多名员工。",
      descript2:
        "随着中国户外广告市场的高速发展，德高在中国的表现已成为集团全球市场中的一个亮点，作为中国优秀的户外广告公司，德高中国在地铁媒体、公交、机场及接到设施媒体等四大领域内提供最佳服务。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "德高中国在 12 个城市部署的广告屏设备安全管理难度大，目前自研技术实现周期长，成本高。",
      },
      item2: {
        title: "问题二",
        description:
          "自研 B2B、B2E 的广告投放平台等多个应用的身份管理和授权，以及完成多应用与广告设备的授权登录，给研发团队带来了极大的工作量。",
      },
      item3: {
        title: "问题三",
        description:
          "1000+ 广告设备无法实现统一管理和运营策略，给运维人员带来极大的工作量。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "针对德高中国自研广告投放平台的统一身份认证和管理问题，采用 Authing 身份云产品，帮助打通员工对设备的集中访问管控，构建城市区域中心认证节点，提升设备认证可用性、稳定性和性能，同时对应用状态实时监控，确保设备统一管理和安全。",
      },
      item2: {
        title: "",
        subtitle:
          "直接调用 Authing 基于身份管理的 API 接口，快速实现企业内身份供给和管理，实现员工账号及组织开通、启动、禁用，删除及停用功能，针对下游提供用户及组织信息同步。",
      },
      item3: {
        title: "",
        subtitle: "接入企业内部应用系统，完成账号同步，单点登录和访问授权。",
      },
    },
  },
  "bentley-motors": {
    banner: {
      title: "Bentley",
      addtionTitle: "（宾利汽车）",
      subtitle:
        "Authing 平台的规则和映射功能的结合使我们能够轻松地处理用户登录的任何数据。最重要的是，我们不必要求合作伙伴以不同的格式发送数据，SSO 可以满足他们的需求。Authing 大大减少了我们的运维工作量。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-bentley-motors-zh.png",
      descript1: `宾利（Bentley Motors Limited），宾利是世界优质汽车的制造商之一，总部位于英国克鲁。 
        “To build a fast car, a good car, the best in its class.” 曾是创始人华特·欧文·宾利先生最初追求极致卓越的造车理念。
        近一个世纪之后，宾利先生的理念仍继续指引其信念、行动和宏大目标。宾利汽车居顶级英国豪华汽车之列，手工打造全世界最佳性能的豪华旅行轿车，宾利在1997年被大众集团收购。`,
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "宾利汽车研发团队需要打造企业内部统一的身份源，为企业内部员工实现统一身份认证和授权功能，提高研发工作效率，减少运维工作量。",
      },
      item2: {
        title: "问题二",
        description:
          "企业自研应用，统一身份登录认证和管理授权功能不能复用，新旧应用身份集成存在困难。",
      },
      item3: {
        title: "问题三",
        description:
          "面向集团内部数百用户及上下游合作伙伴，企业 B2B、B2E 容器云平台，想要实现合规的安全的身份登录认证体系。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 统一的身份解决方案支持多合作伙伴的身份验证，快速、敏捷，与现有应用实现无缝对接。",
      },
      item2: {
        title: "",
        subtitle:
          "Authing 身份云基于规范的工作流来处理宾利内部及所有上下游供应商的身份验证要求，让用户账密登录更安全合规。",
      },
      item3: {
        title: "",
        subtitle:
          "统一的身份源，帮助宾利汽车集成内部自研应用系统，完成用户账密同步、单点登录、访问授权和多因素认证。提供审计日志的存储和记录，利于数据安全和问题溯源。",
      },
    },
  },
  yuanqi: {
    banner: {
      title: "元气森林",
      addtionTitle: "",
      subtitle:
        "Authing 打通飞书产品，为我们提供身份源能力，快速的部署及开发者友好，满足了我们现有和未来的需求，为我们节省了大量的研发人力、费用和周期，让我们将这些宝贵的资源更多应用在公司和客户上。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-yuanqi.png",
      descript1:
        "2016 年成立的元气森林食品科技集团是自主研发、自主设计的创新型饮品公司。品牌秉持“用户第一”的使命，立足健康需求，破除口味壁垒，传递健康生活理念。目前，元气森林系列产品已覆盖全国，并出口美国、新西兰、新加坡等40多个国家和地区。",
      descript2:
        "元气森林一直在学习传统行业的玩法，又在颠覆传统行业的玩法。2020 年前，元气森林线上与线下销量比为 7：3，而在 2021 年，线下销量将有可能超越线上。在上年度《第一财经》发布的金字招牌榜单上，元气森林荣登碳酸饮料榜榜首。与此同时，元气森林 2020 年的年销售额也达到约 30 亿。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "元气森林目前 5000 多员工的应用登录管理和授权问题，且随着员工的不断增长，传统 IAM 难以解决不断扩容的问题，如何使用通用登录来管理内部用户的角色和权限，确保安全内置到每个员工对应的级别系统，是目前运维人员管理的难点。",
      },
      item2: {
        title: "问题二",
        description:
          "内部几十个应用系统的集成，与身份体系的打通，集成飞书，通过飞书将组织架构体系打通，实现员工单点登录，目前自研力度较大，时间周期长。",
      },
      item3: {
        title: "问题三",
        description:
          "希望寻找一个身份云提供商，解决不断增长的应用和员工规模，应对企业未来不断扩张带来可持续的增长和高效率。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 突破性的单点登录技术，无需任何开发，快速助力元气森林实现员工一个账号密码登录所有应用，并统一管控身份权限。",
      },
      item2: {
        title: "",
        subtitle:
          "Authing 通过与飞书产品层面的打通，为元气森林提供身份供应，实现基于飞书组织架构下的不同权限不同访问级别，节省运维人员 80% 的工作量。",
      },
      item3: {
        title: "",
        subtitle:
          "Authing 为元气森林提供一站式团队应用平台，实现成员和集中管控访问权限，打造高效的办公方式，简化人事、IT管理，加速企业成长。",
      },
    },
  },
  volkswagen: {
    banner: {
      title: "大众汽车",
      addtionTitle: "",
      subtitle:
        "Authing 为我们提高效率，减少开发运维费用，并节省了宝贵的时间和资源。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-story-detail-intro-volkswagen.png",
      descript1:
        "大众汽车（德语：Volkswagen）是一家总部位于德国沃尔夫斯堡的汽车制造公司，也是世界四大汽车生产商之一的大众集团的核心企业。2019 年位居《财富》世界 500 强第9 位。",
      descript2:
        "大众汽车传承优良的造车 DNA ，更着力研发创新性的智能科技。大众不断突破现实的壁垒，用技术将想象落地，为人们出行创造更多可能性。每一项有意思的科技，都让出行更有意思。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "大众旗下众多品牌及上下游合作伙伴供应商都需登录集团诸多应用，且各应用之间访问时的身份互认，是现在研发团队的难点。",
      },
      item2: {
        title: "问题二",
        description:
          "老旧应用与新研发的应用之间，没有实现身份集成，账号互相隔离，形成信息孤岛。访问不同系统时，需要多次认证，用户体验不佳。",
      },
      item3: {
        title: "问题三",
        description:
          "业务及管理越来越需要快速交付不要的信息以及应用系统，救火式的应对难以应付，需要统一规范的身份体系来支撑快速交付。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 统一的身份解决方案帮助大众汽车完成了应用系统用户身份的认证，授权管理和认证保证用户登录安全可控。",
      },
      item2: {
        title: "",
        subtitle: `Authing 联邦认证通过标准协议将不同的身份提供商联合起来对用户进行认证，帮助大众汽车上下游合作伙伴各应用提供商之间建立信任关系，实现账号同步、单点登录和访问授权。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 可伸缩性、高扩展的 SaaS  平台部署模式，帮助大众汽车实现多用户和应用的连接，以及面向未来应用扩展的需求。",
      },
    },
  },
  toyota: {
    banner: {
      title: "丰田",
      addtionTitle: "",
      subtitle:
        "无需重新构建或重复构建身份登录体系，通过 Authing 的身份源，即可快速集成我们的新老应用，大大减缩减了我们新应用的研发周期和上市时间。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-toyota.png",
      descript1:
        "丰田汽车公司成立于 1937 年，距今已有八十多年的历史。丰田在中国的事业可追溯至1964 年对华出口首批 CROWN 皇冠轿车。长久以来，丰田一直致力于为中国广大消费者不断提供高品质的产品和服务，切实履行企业社会责任，从而为社会和汽车产业的可持续发展做贡献。如今，丰田已在中国设立 28 家主要的独资和合资公司，2019 年，在华销量达到 162 万辆，为丰田在华历史最好成绩。",
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "研发团队需要开发 B2C 租车业务应用，统一身份认证功能开发周期长、拖累核心应用开发进度，需要统一规范的身份体系来支撑快速交付。",
      },
      item2: {
        title: "问题二",
        description:
          "原有应用身份认证系统不能复用到新应用中，新旧应用身份集成存在困难。 新应用万级以上的用户身份认证和管理，给运维带来极大工作量。",
      },
      item3: {
        title: "问题三",
        description:
          "用户数据安全问题，现有的用户管理流程不够清晰，覆盖不全面，存在一些管理薄弱点及落实不到位问题，无法满足行业监管审计的要求。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 提供的 SaaS 标准化身份云产品，为日本丰田提供身份供应源，帮助丰田研发团队快速部署身份安全管理平台，缩短新应用研发的周期。",
      },
      item2: {
        title: "",
        subtitle: `接入企业现有应用系统，完成身份账号同步、单点登录和访问授权问题。Authing 针对开发者友好的可扩展性、高伸缩性，满足丰田后续开发新应用中的身份登录及 C 端用户万级用户的流量问题。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 的自适应多因素认证功能，提升用户完全登录，提升信息安全，强化风险控制。安全合规，提升身份治理水平。",
      },
    },
  },
  huaxi: {
    banner: {
      title: "华西医院",
      addtionTitle: "",
      subtitle:
        "Authing 为我们构建了身份供应体系，减少新应用集成的身份源问题，减少因人员身份管理不规范带来的信息安全、隐私风险及运营风险。通过身份安全管理平台建设，保障信息符合国家相关要求和规范，实现技术合规及政策合规。我们非常期待 Authing 为更多组织带去价值。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-hospital.png",
      descript1:
        "四川大学华西医院（West China Hospital，Sichuan University）是中国西部疑难危急重症诊疗的国家级中心，也是世界规模第一的综合性单点医院，拥有中国规模最大、最早整体通过美国病理家学会（CAP）检查认可的医学检验中心。 在2015年公布的中国公立医院社会贡献度排行榜上总分位列全国第一，连续多年被独立第三方调查评选为“全国最受欢迎三甲医院” 前十强、“医疗机构最佳雇主”前十强。 华西医院现阶段自研医疗软件和内外部应用系统较多，作为特殊的医疗行业，在身份登录安全上和统一管理上要求更高。",
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "华西医院目前没有对用户进行各系统的访问权限进行统一管理，对用户管理缺乏技术的有效控制，容易对应用系统造成信息安全隐患。",
      },
      item2: {
        title: "问题二",
        description:
          "华西医院自研应用与内部现有应用身份的集成，身份供应体系研发成本高，难以复用，造成  IT 资源的浪费，零散的用户管理体系给审计带来了非常大的难度，运维成本高。",
      },
      item3: {
        title: "问题三",
        description: "缺乏清晰实时操作和访问审计，无法满足企业合规要求。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "针对华西医院对接自研系统的需求， Authing 的应用集成网关产品帮助华西快速实现应用的集成和身份源的管理。 ",
      },
      item2: {
        title: "",
        subtitle: `接入华西内部应用系统，完成账号同步、单点登录和访问授权。提供用户身份源相关的审计日志存储和记录，方便管理者追溯。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 提供统一身份管理平台的认证和授权，帮助华西医院实现单点登录，让用户登录更为安全便捷，大大降低了运维人员对用户管理的时间成本和投入。",
      },
    },
  },
  bosch: {
    banner: {
      title: "BOSCH",
      addtionTitle: "",
      subtitle:
        "Authing 对开发者友好，实施快速，基础设施要求门槛低，他们简单的演示和专业知识，使 Authing 极具吸引力，很大的帮助我们节省了部署时间成本及研发周期。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-bosch.png",
      descript1:
        "博世集团是德国的工业企业之一，是全球第一大汽车技术供应商，从事汽车与智能交通技术、工业技术、消费品和能源及建筑技术的产业。员工人数超过 27万，遍布 50 多个国家。博世以其创新尖端的产品及系统解决方案闻名于世。 博世在中国设立了 11 个独资公司，9 个合资公司和多个贸易公司等，博世正大力支持中国汽车市场的强劲增长。自进入中国市场以来，博世中国不断将先进技术和解决方案引入中国，并参与了一系列中国的重大工程项目。如今，博世的技术又在推陈出新，把技术载入生活，它正在改变人的生活。",
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "可持续的发展对于博世集团这样拥有数百个不同应用、不同产品、不同部门的扩张型公司来说至关重要。在不断扩充的客户、不断推向市场的各类设备进行管理是集团目前面临的问题。",
      },
      item2: {
        title: "问题二",
        description:
          "对于博世用户和设备的连接，怎么进行身份验证，保障访问的安全，访问的权限问题都给研发团队带来极大的困扰。",
      },
      item3: {
        title: "问题三",
        description:
          "多设备和用户的管理，运维人员效率低下且易出错，大量的重复的用户数据需要做冗余存放和同步管理，如何快速调整因设备业务等原因造成的用户变更问题。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 统一的身份解决方案帮助博世集团完成了所有设备和用户身份的认证，授权管理和认证保证用户登录安全可控。",
      },
      item2: {
        title: "",
        subtitle: `Authing 平台提供设备及用户账号的开通、启用、禁用、删除等功能，对下游提供用户与设备信息的同步，并帮助博世集团实现多用户和多设备连接，以及面向未来设备与应用扩展的需求。`,
      },
      item3: {
        title: "",
        subtitle: "接入企业内部应用系统，完成账号同步、单点登录和访问授权。",
      },
    },
  },
  pingcap: {
    banner: {
      title: "PingCAP",
      addtionTitle: "",
      subtitle:
        "高科技创新的产品，灵活敏捷，响应速度快。没想到我们 40 多个应用的单点登录、协同办公和基于身份供应的上下游需求，用 Authing 产品很快就帮我们实现了需求。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-pingcap.png",
      descript1:
        "PingCAP 是一家企业级开源分布式数据库厂商，提供包括开源分布式数据库产品、解决方案与咨询、技术支持与培训认证服务。 由 PingCAP 创立的分布式关系型数据库 TiDB，为企业关键业务打造，具备「分布式强一致性事务、在线弹性水平扩展、故障自恢复的高可用、跨数据中心多活」等企业级核心特性，帮助企业最大化发挥数据价值，充分释放企业增长空间。目前，PingCAP 已经向包括中国、美国、欧洲、日本、东南亚等国家和地区，超过 1500 家企业提供服务，涉及金融、运营商、制造、零售、互联网、政府等多个行业。",
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "PingCAP 在长达 3 年的时间里一直存在多个员工身份源，在公司组织机构、跨平台的管理上存在难点，包括飞书，北森，Google 等接近 40 个应用之间的单点登录、协同办公和组织的管理需求。",
      },
      item2: {
        title: "问题二",
        description:
          "PingCAP 在国内、海外多个国家都有办公室，怎样做好各国员工身份管理，降低身份管理和运营成本是现阶段亟待解决的问题。  ",
      },
      item3: {
        title: "问题三",
        description:
          "PingCAP 希望可以通过北森 HR 系统作为企业统一身份源，进行海内外员工入职、单点登录、协同办公（项目组管理）、离职等自动化管理，能够搭建一个身份中台，管理和同步员工信息、组织机构，并可扩展到下游应用中，减少身份重复产研建设。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "基于 OIDC、SAML 协议，Authing 帮助 PingCAP 对接现有全部应用，Authing 的身份供应帮助 PingCAP 实现 单点登录 SSO 的功能，实现使用一个账号登录企业所有应用。",
      },
      item2: {
        title: "",
        subtitle: `基于 SCIM、LDAP 协议实现组织机构供给能和 Authing 身份供给能力，实现 PingCAP 员工身份上下游同步供给的能力，可扩展高可用。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 对员工入离职管理和信息同步的产品能力，帮助 PingCAP 大大降低了运维时间和成本。",
      },
    },
  },
  "alpha-cen": {
    banner: {
      title: "Alpha Cen",
      addtionTitle: "",
      subtitle:
        "在苹果公司和德州仪器的经验，让我们深知统一身份管理要从 day 1 做起。Authing 提供了各类工程软件及平台的接口，文档详细且易读。这使我们只需用很少的精力，就能搭建起完整的身份认证管理平台。",
    },
    intro: {
      title: "客户介绍",
      imgUrl: "",
      descript1:
        "Alpha Cen 是一家源自美国硅谷的高科技创业公司。创始人团队来自于加州理工学院、斯坦福大学、苹果、德州仪器，具备从底层材料、器件创新、芯片设计、稳定出货终端产品的全栈研发能力。",
      descript2:
        "创始人团队拥有 10 年全球著名实验室纳米光学和纳米加工经验，10 年业内顶级公司硬件和集成电路架构设计经验；曾发布多款工业、消费、车载市场芯片，产品被广泛应用于 Google 数据中心、特斯拉 Model 3、LG OLED 电视等产品当中。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "公司创立后，上线了多种应用系统，每个系统都涉及了身份认证、权限管理的问题，但因为数据不互通，没办法进行统一的管理。",
      },
      item2: {
        title: "问题二",
        description:
          "因为涉及众多应用，CEO 非常重视成熟的接口方案，希望能快速地和飞书、AD 深度打通，减少对接成本与重复建设。",
      },
      item3: {
        title: "问题三",
        description:
          "采购外部的系统常有上线周期偏长、学习成本高的问题。CEO 希望统一身份管理产品足够简单，搭建好后无需投入太多运维和监控人力。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "通过 Authing 搭建统一身份认证管理平台，能帮助企业统一多个系统的身份源、自动化的同步数据，并设置细粒度的权限管理，在提效的同时保障信息安全。",
      },
      item2: {
        title: "",
        subtitle:
          "Authing 预集成了 2000+ 应用，通过后台设置可以快速打通飞书、钉钉、企微、AD 等海内外身份源；自研应用也可以基于标准身份协议进行集成。",
      },
      item3: {
        title: "",
        subtitle:
          "Authing 积累了丰富的技术文档，在没有外部工程师介入的情况下，企业内部也能基于文档自行完成系统的上线和运作，学习成本和对接成本极低。",
      },
    },
  },
  nreal: {
    banner: {
      title: "Nreal",
      addtionTitle: "",
      subtitle:
        "我们 8 月 23 日在北京举办的首场 AR 眼镜发布会圆满成功，目前用户稳步增长中，系统运行稳定。感谢 Authing 的耐心与细致，给予我们大力支持，希望和 Authing 的合作能再接再厉，一起共同成长！",
    },
    intro: {
      title: "客户介绍",
      imgUrl: "",
      descript1:
        "Nreal 成立于 2017 年，是率先在全球范围内推出消费级 AR 眼镜的公司，以其卓越的显示技术和产品设计而获得广泛认可，目前已与 10 多家全球知名运营商建立合作伙伴关系，并已将其产品带到 6 个国家。",
      descript2:
        "在 2021 年，Nreal 市场份额达 75%，并在 2022 年上半年上升至 81%，成为全球销量第一的国产 AR 眼镜品牌。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "身份系统需要在小程序、APP、官网同步上线，并进行身份的统一；但三端涉及多语言的开发，研发成本高。",
      },
      item2: {
        title: "问题二",
        description:
          "考虑到未来用户数增长及业务扩张，身份平台需具备「支持高并发」、「安全稳定」、「高扩展性」的能力。",
      },
      item3: {
        title: "问题三",
        description:
          "在海外已经使用成熟的 IDaaS 产品来搭建身份底座，但进军中国大陆市场，希望接入更符合当地法规和生态的 IDaaS 产品。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 提供 1000+ API 和多语言的 SDK，可灵活适配小程序、App、官网等场景，实现三端的身份统一，大幅节省研发工作量。",
      },
      item2: {
        title: "",
        subtitle: `Authing 基于云原生架构，最高可在 3 分钟内承载 100 万次的登录访问。此外，企业可通过自动化的 pipeline、扩展字段等能力，为精准营销打下基础。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 提供的统一身份底座，不仅符合中国的应用生态和法规，开发者也能快速接入外采和自研应用，完美替代国外相关产品。",
      },
    },
  },
  cocacola: {
    banner: {
      title: "太古可口可乐",
      addtionTitle: "",
      subtitle:
        "我们目前内外部用户众多，涉及几十个应用系统的手工创建、删除、账户生命周期管理等，工作量巨大，容易错漏造成安全隐患。而 Authing 帮助我们解决了身份安全的挑战。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-cocacola.png",
      descript1:
        "太古可口可乐是一家全品类饮料公司，在全球 200 多个国家和地区提供 500 多个品牌的饮料。从减少饮料中的糖分到引入创新型产品，公司的产品组合不断推陈出新。可口可乐公司始终致力于减少对环境的影响，努力推动水回馈和包装的回收再利用。在中国，太古可口可乐为消费者提供 20 多个品牌、约 100 多种产品的饮料选择。在华建有 46 家工厂，系统员工超过 49,000 人。在业务不断发展的同时，可口可乐中国与装瓶合作伙伴也⻓期致力于实现当地社会的可持续发展，在乎消费者多元的饮料需求，在乎产品的质量，在乎社区的发展，在乎环境的共生。",
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "涉及中国区（含香港）20000 多员工岗位周期各状态下的身份管理，让IT运维管理人员面临极大的挑战，包括人员入离职、调岗、兼职、返聘等账户管理批量开通和回收滞后，访问存在安全⻛险，没有进行统一授权管理。",
      },
      item2: {
        title: "问题二",
        description:
          "企业内部十几个老旧应用无法完成身份集成：企业在六七年前开始寻求解决方案，在当前背景下触达的十几个同类型供应商后都无法彻底解决困扰多年的难题。",
      },
      item3: {
        title: "问题三",
        description:
          "员工需要记忆几十个用户名/密码，密码策略不同，认证方式多样。访问不同系统时，需要多次认证，员工体验不佳。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 提供的统一身份登录方案，通过员工账户同步，基于 AD、AAD、企业微信、自研系统等几十个应用的员工账户合并，为可口可乐实现一个企业微信账号登录所有应用的能力。",
      },
      item2: {
        title: "",
        subtitle: `Authing 帮助可口可乐实现企业微信扫码登录，解决员工多账户、多密码、多应用切换登录的痛点，提高员工满意度和体验。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 自动化账号生命周期管理代替可口可乐当前手动式账号管理，批量管理员工入离职、授权应用和⻆色、停用、归档、删除、组织架构调整等工作。建立单一身份源，将身份同步中的属性信息至统一目录，向外输出唯一标准数据，便于 IT 管理。",
      },
    },
  },
  csdn: {
    banner: {
      title: "CSDN",
      addtionTitle: "",
      subtitle:
        "Authing 开箱即用的 API/SDK，帮我们缩短了一个月的研发周期， 打造强大的 One-ID 身份管理中台，大幅提升了用户体验。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-cocacola.png",
      descript1:
        "CSDN（中国开发者网络）创立于 1999 年，是全球知名的中文开发者网站。秉承成就一亿技术人的使命，为 IT 技术人成长及科技企业发展，提供开发者生态的全方位服务。CSDN 在社区基础上，通过知识云、人才云、开发云三大服务，赋能开发者、研发团队及科技企业在 IT 知识学习、人才招聘、研发效能与协同管理等方面的高速成长与发展。目前已经有 3500 万注册用户；1000 万/月活跃用户；覆盖中国 90% 以上中文开发者和 70% 以上 IT 专业人士。",
      descript2: "",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "搭建用户身份管理体系的任务繁重，涉及多个平台的联动，缺少接口和通用的权限模型，难以在较短的项目周期内完成开发。",
      },
      item2: {
        title: "问题二",
        description:
          "考虑到平台未来的扩展，希望提供用户更多元的登录体验，涵盖国内外社会化登录方式，并形成 One-ID 的统一身份管理策略。",
      },
      item3: {
        title: "问题三",
        description:
          "平台运营涉及多方的联合，需要细粒度、模块化的功能 API/SDK 提供给不同角色，兼顾运营的开放性和身份数据的安全性。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 提供 1000+ API，并支持主流开发语言的 SDK，帮助 CSDN 缩短了一个月的研发周期，使 CSDN 能专注于业务能力的研发。",
      },
      item2: {
        title: "",
        subtitle: `通过 Authing Guard 和 32 种国内外的社会化登录能力、第三方身份关联配置，能够达成高度定制化的用户登陆体验和 One-ID 的统一身份管理策略。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 提供的 PBAC 权限模型，能够实现 API、数据、菜单、按钮级别的细粒度权限管理；还支持通过接口拉通组织和用户角色，进行统一管理。",
      },
    },
  },
  unicredit: {
    banner: {
      title: "意大利裕信银行",
      addtionTitle: "",
      subtitle:
        "Authing 产品具备开发者友好的特质，对基础设施的要求门槛低，能帮助我们快速实施完成。通过 Authing 专业的演示和完备的技术文档，我们大幅节省了部署时间及研发周期。",
    },
    intro: {
      title: "客户介绍",
      imgUrl:
        "//files.authing.co/authing-website/customer-detail-intro-cocacola.png",
      descript1:
        "意大利裕信银行是一家总部设在意大利米兰的欧洲银行，也是欧洲最大的银行集团之一，已经在米兰交易所上市，核心业务在意大利、奥地利和德国南部等地区。意大利裕信银行提供个人投资、商务银行业务、国际业务、电话服务、信用卡、存贷款业务等服务，拥有 4000 万以上的用户，遍及 22 个国家。",
      descript2:
        "意大利裕信银行在中欧和东欧也有大量的业务。按照资产总额算，拥有 910 亿欧元资产的意大利联合信贷银行是欧元区第一大、欧洲第三大和世界第六大的银行集团。",
    },
    challenge: {
      title: "需求挑战",
      item1: {
        title: "问题一",
        description:
          "意大利裕信银行对数据安全有着高度的重视，希望保障员工安全合规地登录银行内部应用，实现安全统一的身份认证与管理。",
      },
      item2: {
        title: "问题二",
        description:
          "企业内部有数千员工，需要更完善、强大的员工身份管理能力。但自研实现的难度大、周期长、成本高，不合乎效益。",
      },
      item3: {
        title: "问题三",
        description:
          "金融行业涉及大量用户的隐私信息，对数据有更严格的保护要求，不支持公有云部署，导致身份治理产品选型困难。",
      },
    },
    ideas: {
      title: "想法变现实",
      item1: {
        title: "",
        subtitle:
          "Authing 具备多元的多因素认证方式和自适应的安全策略，企业根据自身需求进行选择和配置，能实现更安全的登录认证。",
      },
      item2: {
        title: "",
        subtitle: `Authing 提供 1000+ 身份认证与权限管理相关的 API/SDK，能帮助企业快速部署负复杂的功能，有效缩短开发时间。`,
      },
      item3: {
        title: "",
        subtitle:
          "Authing 采用 Kubernetes 容器化技术，同时支持公共云、混合云和私有云部署；具分钟级别弹性扩容能力，最大可支持亿级别用户认证访问场景。",
      },
    },
  },
};
